import { useParams } from "react-router-dom";
import { useCompanyInfo } from "@/api/services/main/company";
import { useCompanyUserInfo } from "@/api/services/main/company-user";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { CompanyUserEditContent } from "@/features/company/components/company-user/CompanyUserEditContent";
import { useValidateId } from "@/hooks/useValidateId";
import { AppRoutes } from "@/routes/config";

const CompanyUserEditPage = () => {
  const { companyId, userId } = useParams();
  const companyQuery = useCompanyInfo();
  const userQuery = useCompanyUserInfo(companyId, userId);

  useValidateId("companyId", AppRoutes.companyList, companyQuery);
  useValidateId("userId", AppRoutes.companyList, userQuery);

  const { data: companyData, isLoading: isCompanyLoading } = companyQuery;
  const { data: userData, isLoading: isUserLoading } = userQuery;

  if (!companyData || !userData || isCompanyLoading || isUserLoading) return <LoadingPage />;

  return <CompanyUserEditContent companyData={companyData.data} userData={userData.data} />;
};

export default CompanyUserEditPage;
